function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { $unibase } from '../uni-base-module';
import { NotificacionService } from './NotifService';
import { RestProxy } from './rest-proxy';
export var AccesoServicios = /*#__PURE__*/function () {
  AccesoServicios.$inject = ["$http", "$log", "$q", "$resource", "NotifService"];
  function AccesoServicios($http, $log, $q, $resource, NotifService) {
    _classCallCheck(this, AccesoServicios);
    _defineProperty(this, "_urlBaseServiciosRoot", '');
    this.$http = $http;
    this.$log = $log;
    this.$q = $q;
    this.$resource = $resource;
    this.NotifService = NotifService;
    var transformResponseDefault = this.$http.defaults.transformResponse && this.$http.defaults.transformResponse instanceof Array ? this.$http.defaults.transformResponse[0] : this.$http.defaults.transformResponse;
    if (transformResponseDefault) {
      var _transformDefault = transformResponseDefault;
      var transformError = function transformError(data, headersGetter, status) {
        if ((status === 417 || status === 406) && typeof data === 'string') {
          try {
            angular.fromJson(data);

            // es json, no tratarlo
          } catch (e) {
            // es solo un mensaje
            return {
              statusText: data
            };
          }
        }
        return _transformDefault(data, headersGetter, status);
      };
      this.$http.defaults.transformResponse instanceof Array && this.$http.defaults.transformResponse.unshift(transformError);
    }
  }
  return _createClass(AccesoServicios, [{
    key: "gestionaErrorServiciosDeprecated",
    value: function gestionaErrorServiciosDeprecated(deferred, errorArgs, msg) {
      this.$log.warn('** deprecated');
      if (errorArgs && errorArgs.length) {
        // puede ser un arguments, tiene más de 1 elemento
        var data = errorArgs[0];
        if (data.mensaje) {
          msg = msg + ':\n\n' + data.mensaje;
        } else {
          // no hay mensaje, caso especial
          if (errorArgs.length > 1 && '403' == errorArgs[1]) {
            // es un acceso denegado
            msg = msg + ':\n\n' + '*** Acceso denegado para esta operación ***';
          }
        }
      }
      this.NotifService.alert(msg);
    }
  }, {
    key: "error",
    value: function error(deferred, errorArgs, msg) {
      return this.gestionaErrorServicios(deferred, errorArgs, msg);
    }

    /**
     * Este método por defecto limpia el loading
     *
     */
  }, {
    key: "gestionaErrorServicios",
    value: function gestionaErrorServicios(deferred, errorArgs, msg) {
      var _this = this;
      // errorArgs es [ data, status, headers, config ]

      this.intentaGestionar(deferred, errorArgs, msg).then(function (gestionado) {
        gestionado || _this.gestionaErrorServiciosDeprecated(deferred, errorArgs, msg);
      });
    }
  }, {
    key: "intentaGestionar",
    value: function intentaGestionar(deferred, errorArgs, msg) {
      return this.NotifService && this.gestionaErrorNotif(deferred, errorArgs, msg);
    }
  }, {
    key: "gestionaErrorNotif",
    value: function gestionaErrorNotif(deferred, errorArgs, msg) {
      this.NotifService.loading.clear();

      // gestionando por notificación
      return this.NotifService.error(deferred, errorArgs, msg);
    }

    // xhr es [ config, data, headers, status, statusText ]
  }, {
    key: "resourceErrorHandler",
    value: function resourceErrorHandler(xhr, defaultMsg) {
      // jsc 20171108 gestionar en notifservice
      if (xhr && angular.isDefined(xhr.data) && NotificacionService) {
        this.gestionaErrorServicios(null, [xhr.data, xhr.status, xhr.headers, xhr.config], defaultMsg);
        return;
      }
      if (xhr) {
        if (xhr.data && xhr.data.mensaje) defaultMsg = defaultMsg + '\n\n' + xhr.data.mensaje;else if (xhr.data && xhr.data.statusText) defaultMsg = defaultMsg + '\n\n' + xhr.data.statusText;else if (xhr.statusText) defaultMsg = defaultMsg + '\n\n' + xhr.statusText;
      }
      this.NotifService.alert(defaultMsg);
    }
  }, {
    key: "defaults",
    value: function defaults(defaultMsg, defaultUrl, extraOps) {
      return this.resourceDefaults(defaultMsg, defaultUrl, extraOps);
    }
  }, {
    key: "resourceDefaults",
    value: function resourceDefaults(defaultMsg, defaultUrl, extra) {
      var _this2 = this;
      var defaultInterceptor = {
        // requestError: (rejection: any) => {
        //   this.resourceErrorHandler(rejection, defaultMsg)
        //   return this.$q.reject(rejection)
        // },
        // response: <T>(response: IHttpResponse<T>) => {
        //   this.$log.debug(response)

        //   return response
        // },
        responseError: function responseError(rejection) {
          _this2.resourceErrorHandler(rejection, defaultMsg);
          return _this2.$q.reject(rejection);
        }
      };

      // this.$http.defaults.transformResponse.unshift(transformError);

      var opts = {
        get: {
          method: 'GET',
          interceptor: defaultInterceptor
        },
        save: {
          method: 'PUT',
          interceptor: defaultInterceptor
        },
        add: {
          method: 'POST',
          interceptor: defaultInterceptor
        },
        query: {
          method: 'GET',
          isArray: true,
          interceptor: defaultInterceptor
        },
        remove: {
          method: 'DELETE',
          interceptor: defaultInterceptor
        },
        "delete": {
          method: 'DELETE',
          interceptor: defaultInterceptor
        },
        savebatch: {
          method: 'PUT',
          isArray: true,
          url: defaultUrl && defaultUrl + '/batch',
          interceptor: defaultInterceptor
        }
      };
      if (extra) {
        // incorporar el interceptor a los actions extra
        angular.forEach(extra, function (action) {
          action.interceptor = action.interceptor || defaultInterceptor;
        });
        opts = angular.extend(opts, extra);
      }
      return opts;
    }
  }, {
    key: "test",
    value: function test() {
      this.NotifService.alert('test');
    }
  }, {
    key: "_get",
    value: function _get(url, config, errorMsg) {
      return this._callParams('get', url, null, config, errorMsg);
    }
  }, {
    key: "get",
    value: function get(url, config, errorMsg) {
      return this._get(url, config, errorMsg);
    }
  }, {
    key: "_call",
    value: function _call(method, url, data, queryParams, errorMsg, options) {
      return this._callParams(method, url, data, {
        cache: false,
        params: queryParams
      }, errorMsg, options);
    }
  }, {
    key: "call",
    value: function call(method, url, data, queryParams, errorMsg, options) {
      return this._call(method, url, data, queryParams, errorMsg);
    }
  }, {
    key: "_callParams",
    value: function _callParams(method, url, data, config, errorMsg, options) {
      var _this3 = this;
      var deferred = this.$q.defer();
      var _m = method.toLowerCase();
      var response = null;
      if ('get' == _m) {
        response = this.$http.get(url, config);
      } else if ('post' == _m) {
        response = this.$http.post(url, data, config);
      } else if ('put' == _m) {
        response = this.$http.put(url, data, config);
      } else if ('delete' == _m) {
        response = this.$http["delete"](url, config);
      }
      if (response) {
        response.then(function (xhr) {
          // xhr => dataResponse, status, headers, config

          _this3.$log.debug(xhr);
          deferred.resolve(xhr.data);
        })["catch"](function (xhr) {
          // xhr => data, status, headers, config

          /* xhr es 
                            config : {method: "GET", transformRequest: Array(1), transformResponse: Array(2), paramSerializer: ƒ, jsonpCallbackParam: "callback", …}
                            data : {timestamp: 1520598927804, status: 400, error: "Bad Request", exception: "org.springframework.web.method.annotation.MethodArgumentTypeMismatchException", message: "Failed to convert value of type 'java.lang.String'…rmatException: For input string: "listnovedadess"", …}
                            headers : ƒ (d)
                            status : 400
                            statusText : "400"
                            xhrStatus : "complete"
                        */

          // gestionar el error si nadie dice lo contrario
          var _gestionaerror = !options || !options._cfg || !options._cfg.nogestionaerror;
          _gestionaerror && _this3.NotifService.error(deferred, [xhr.data, xhr.status, xhr.headers, xhr.config], _this3.__mejoraError(errorMsg, xhr) || 'Error en la operación');
          deferred.reject(xhr);
        });
      } else {
        this.NotifService.alert('LLamada incorrecta al método ' + method);
        deferred.reject('** error');
      }
      return deferred.promise;
    }
  }, {
    key: "__mejoraError",
    value: function __mejoraError(errorMsg, xhr) {
      if (errorMsg) return errorMsg;
      try {
        if (xhr && xhr.data && xhr.data.path && xhr.data.message && xhr.data.message.startsWith('PRIV--')) return xhr.data.message.substring(6);
      } catch (err) {
        console.warn('No se puede obtener msg en xhr', err);
      }
    }

    /** HttpClient */
  }, {
    key: "_restrequest",
    value: function _restrequest(_ref) {
      var method = _ref.method,
        url = _ref.url,
        queryParams = _ref.queryParams,
        data = _ref.data,
        options = _ref.options,
        copyFn = _ref.copyFn;
      return this._call(method, this._urlBaseServiciosRoot + url, data, queryParams, '', options);
    }
  }, {
    key: "_proxyUrl",
    value: function _proxyUrl(baseUrl) {
      return new RestProxy(this, baseUrl);
    }
  }]);
}();
$unibase.service('AccesoServicios', AccesoServicios);
export default AccesoServicios;